export enum CatalogActionTypes {
  GET_CATEGORIES_NAMES = '@catalog/GET_CATEGORIES_NAMES',
  GET_PROVIDERS_NAMES = '@catalog/GET_PROVIDERS_NAMES',
  GET_GAMES_NAMES = '@catalog/GET_GAMES_NAMES',
}
